import React from 'react';
import { motion } from 'framer-motion';
import { Check, Sparkles } from 'lucide-react';
export function RosadoPromo() {
  return <section className="py-8 overflow-hidden" data-id="element-283" data-mp="accrhlqssvfp">
      <div className="mx-auto" data-id="element-284" data-mp="f4e5bc3m6u7u">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-285" data-mp="f5fd97pc30lc">
          {/* Left — Promotional Image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-286" data-mp="k2z3z737x5u6">
            <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-287" data-mp="1e0u90vfezea">
              <img src="https://cdn.magicpatterns.com/uploads/sT1UcU5dfKKo99htaP4iDP/ChatGPT_Image_20_abr_2026,_20_13_45.png" alt="Kit Rosado Premium — Organizado, Elegante, Siempre Contigo" className="w-full h-auto object-cover" data-id="element-288" data-mp="17tbk358ma8vu" />
            </div>
            {/* Decorative accent */}
            <div className="absolute -bottom-4 -left-4 w-full h-full border-2 border-rosado/20 rounded-2xl -z-10" data-id="element-289" data-mp="85mgppgxytmn"></div>
          </motion.div>

          {/* Right — Text */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-290" data-mp="3ud47e21yoji1">
            <span className="text-xs font-bold tracking-[0.3em] uppercase text-rosado mb-4 block" data-id="element-291" data-mp="3bltmc1ix30y2">
              Tu Esencial Beauty Favorito
            </span>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-luxury-black leading-tight mb-6" data-id="element-292" data-mp="36m8hjah2fydf">
              ORGANIZADO. <br data-id="element-293" data-mp="31pzz9o7knp21" />
              ELEGANTE. <br data-id="element-294" data-mp="2rziadsgnvbjx" />
              <span className="italic text-rosado" data-id="element-295" data-mp="2rz02fykmz8w6">SIEMPRE CONTIGO.</span>
            </h2>

            <p className="text-gray-600 font-sans font-light text-lg leading-relaxed mb-8" data-id="element-296" data-mp="2wzebnjxz4ovs">
              El beauty kit diseñado para mujeres que aman verse profesionales,
              mantener todo en orden y llevar estilo a donde vayan.
            </p>

            <ul className="space-y-3 mb-8" data-id="element-297" data-mp="2n2rsr0p7k7we">
              {['Todo en su lugar y fácil acceso', 'Diseño femenino premium', 'Ideal para citas, trabajo o viajes', 'Herramientas esenciales incluidas', 'Compacto y portátil', 'Perfecto para profesionales y principiantes'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-gray-700" data-id="element-298" data-mp="35xgapty5d7gf" data-mpi={i}>
                  <Check className="w-5 h-5 text-rosado shrink-0" data-id="element-299" data-mp="2azjlrgbk6t6" />
                  <span data-id="element-300" data-mp="1n14uhxdcfxke">{item}</span>
                </li>)}
            </ul>

            <p className="font-serif italic text-luxury-black text-lg mb-8 border-l-2 border-gold pl-5" data-id="element-301" data-mp="1mys734otguzy">
              No es solo un kit. Es la forma elegante de llevar contigo todo lo
              que necesitas.
            </p>

            <motion.a href="https://e04whn-0h.myshopify.com/products/kit-rosado-premium-para-extensiones-de-pestanas" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="block text-center w-full sm:w-auto bg-rosado hover:bg-rosado-light text-white font-sans font-medium text-sm tracking-widest uppercase px-12 py-4 rounded-sm transition-colors duration-300 shadow-lg shadow-rosado/20 mb-4" data-id="element-302" data-mp="1rrl8pjoznn7t">
              COMPRAR KIT ROSADO
            </motion.a>

            <p className="flex items-center gap-2 text-xs text-gray-400 tracking-wide" data-id="element-303" data-mp="2kiv49mo0j67a">
              <Sparkles className="w-3.5 h-3.5 text-gold" data-id="element-304" data-mp="u1hvo8q17uon" />
              🔥 Más vendido por mujeres que aman verse impecables
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}